export class Roster {
    constructor() {
        this.endpoint = 'roster'
        this.boot = [{ index : [
            () => {
            }
        ]}]
    }
}